export class PasswordResetVerifyModel {
    loginId: string | null = null;
    phoneNumber: string | null = null;
    code: string | null = null;

    constructor(data?: Partial<PasswordResetVerifyModel>) {
        Object.assign(this, data);
    }
}
